module.exports = __webpack_public_path__ + "img/background-2-transparent.4986abb.png";